/**
 * CTA Section Module
 * Text reveal animation and button fade-in
 */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Initialize CTA text reveal animation
 * Words color from transparent to primary as user scrolls
 */
export function initCtaSection() {
    const sections = document.querySelectorAll('.cta-section');

    sections.forEach(section => {
        const textElement = section.querySelector('.cta-text-reveal');
        const button = section.querySelector('.cta-button');

        if (!textElement) return;

        // Wrap each word in a span
        const text = textElement.textContent.trim();
        textElement.innerHTML = text
            .split(/\s+/)
            .filter(word => word.trim() !== '')
            .map(word => `<span class="word">${word}</span>`)
            .join(' ');

        const words = textElement.querySelectorAll('.word');
        const totalWords = words.length;

        // Create ScrollTrigger for the section
        ScrollTrigger.create({
            trigger: section,
            start: 'top 60%',
            end: 'center center',
            scrub: 1,
            onUpdate: (self) => {
                const progress = self.progress;
                const wordsToShow = Math.ceil(progress * totalWords);

                words.forEach((word, index) => {
                    if (index < wordsToShow) {
                        word.classList.add('is-visible');
                    } else {
                        word.classList.remove('is-visible');
                    }
                });

                // Show button when all words are visible
                if (button) {
                    if (progress >= 0.9) {
                        button.classList.add('is-visible');
                    } else {
                        button.classList.remove('is-visible');
                    }
                }
            }
        });
    });
}
